
    import { mapState, mapGetters } from 'vuex';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faExternalLinkAlt as fasExternalLinkAlt,
    } from '@fortawesome/pro-solid-svg-icons/faExternalLinkAlt';

    import { jobData } from '@/utils/jobData';
    import Filters from '@/components/Utils/Filters';

    export default {
        name: 'JobViewApplyCtaNew',

        components: {
            FontAwesomeIcon,
        },

        mixins: [Filters],

        props: {
            offsiteApplyUrl: {
                type: String,
                default: '',
            },
            buttonClass: {
                type: String,
                default: '',
            },
            buttonSize: {
                type: String,
                default: 'lg',
            },
        },

        data() {
            return {
                spinner: {
                    applying: false,
                    apply_again: false,
                },
                icons: {
                    fasExternalLinkAlt,
                },
            };
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
                $_job: state => state.job.job,
                $_scoringData: state => state.me.scoringData,
                $_isApplyEnabled: state => state.job.is_apply_enabled,
            }),

            ...mapGetters('me', {
                $_hasRecentResume: 'hasRecentResume',
            }),

            $_jobData() {
                return {
                    c1_datalayer_source: 'c1',
                    seeker_data: this.$_scoringData,
                    ...jobData(this.$_job),
                };
            },

            successApplyRedirectUrl() {
                return `/discover?uuid=${this.$_job.uuid}`;
            },
        },

        methods: {
            apply() {
                this.spinner.applying = true;
                this.$emit('apply');
                setTimeout(() => {
                    this.spinner.applying = false;
                }, 3000);
            },
        },
    };
